import { Injectable } from '@angular/core';
import { AjustesBasicos } from '../yalo.types';
import { take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ConfigsService
{

  // Configuraciones
  public simboloMoneda = ' ';
  private monedaLoadSubject = new BehaviorSubject<boolean>(false);
  public monedaLoad$ = this.monedaLoadSubject.asObservable();

  constructor(private readonly http: HttpClient)
  {
    this.getAjustes().pipe(take(1)).subscribe();
  }

  getAjustes()
  {
    return this.http
      .get<AjustesBasicos>(`${environment.API_URL}/AjustesBasicos`)
      .pipe(tap((ajustes) =>
      {
        this.simboloMoneda = ajustes.SimboloMoneda;
        this.monedaLoadSubject.next(true);
      }));
  }
}
